import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {leaveFeedback} from "../../../questions/actions";
import {Feedback} from "../../../questions/types";

export default function leaveFeedbackHandler(action: ActionType<typeof leaveFeedback>): IAnalyticsAction | undefined {
    if (!action.payload.feedback)
        return;

    return {
        category: "question",
        object: "feedback",
        name: action.payload.feedback === Feedback.Like ? "like" : "dislike",
        postId: action.payload.questionId,
   };
}